import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import T from 'i18n-react';
import IssueFieldInlineEdit from '../../../../../../IssueFieldInlineEdit';
import MultiUserSelectionInlineEdit from '../../../../../../MultiUserSelectionInlineEdit';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../../../../../constants/issue-attribute-names';
import { STATUS_OPEN } from '../../../../../../../constants/status-types';

class CoReviewersInlineEdit extends PureComponent {

  constructor(props) {
    super(props);
    const { issue } = this.props;

    this.state = {
      value: issue[ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS],
    };
  }

  render() {
    const { issue, users, container, className, styleType } = this.props;
    if (issue.status !== STATUS_OPEN) {
      return null;
    }
    const classes = classNames('CoReviewersInlineEdit', className);

    return (
      <MultiUserSelectionInlineEdit
        issue={issue}
        className={classes}
        data-testid="CoReviewersInlineEdit"
        styleType={styleType}
        attributeName={ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS}
        label={T.translate('new.coReviewers')}
        users={users}
        container={container}
        infoMessage={T.translate('info.rfiCoReviewers')}
      />
    );
  }
}

CoReviewersInlineEdit.displayName = 'CoReviewersInlineEdit';


CoReviewersInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  users: PropTypes.array.isRequired,
  container: PropTypes.object.isRequired,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
};

export default CoReviewersInlineEdit;
